/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The DayAvailability model module.
 * @module model/DayAvailability
 * @version 1.0.0
 */
class DayAvailability {
    /**
     * Constructs a new <code>DayAvailability</code>.
     * @alias module:model/DayAvailability
     */
    constructor() { 
        
        DayAvailability.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>DayAvailability</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/DayAvailability} obj Optional instance to populate.
     * @return {module:model/DayAvailability} The populated <code>DayAvailability</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DayAvailability();

            if (data.hasOwnProperty('check')) {
                obj['check'] = ApiClient.convertToType(data['check'], 'Boolean');
            }
            if (data.hasOwnProperty('value')) {
                obj['value'] = ApiClient.convertToType(data['value'], 'String');
            }
        }
        return obj;
    }


}

/**
 * Indica si está disponible
 * @member {Boolean} check
 */
DayAvailability.prototype['check'] = undefined;

/**
 * Valor de la disponibilidad
 * @member {String} value
 */
DayAvailability.prototype['value'] = undefined;






export default DayAvailability;

